query GetChannelDashboard($input: DashboardInput!) {
    channelDashboard(input: $input) {
        stats {
            delta {
                timespanSuffix
                direction
                percentChange
            }
            name
            formattedValue
        }
    }
}
